module.exports = __webpack_public_path__ + "static/media/logo-compacto.3f69cae8.svg";